import gql from 'graphql-tag';

export const CROPS_QUERY = gql`
  query CropsHome {
    crops(filters: [{ name: "crop.status", operator: "!=", value: "archived" }]) {
      edges {
        node {
          id
          crop_name
          status
          yield_per_tray
          yield_unit
          total_grow_time
          sowing_density
          sow_density_unit
          steps {
            edges {
              node {
                id
                name
                time_to_start_after_first_step
              }
            }
          }
        }
      }
    }
  }
`;

export const CROPS_EXPORT_QUERY = gql`
  query CropsExport {
    crops(filters: [{ name: "crop.status", operator: "!=", value: "archived" }]) {
      edges {
        node {
          id
          crop_name
          total_grow_time
          max_hold_time
          harvest_buffer_time
          sowing_density
          sow_density_unit
          yield_per_tray
          yield_unit
          notes
          buffer_percentage
          sizes {
            size
            unit
          }
          steps {
            edges {
              node {
                id
                name
                time_to_start_after_first_step
                description
              }
            }
          }
        }
      }
    }
  }
`;

export const ARCHIVED_CROPS_QUERY = gql`
  query ArchivedCropsHome {
    crops(filters: [{ name: "crop.status", operator: "=", value: "archived" }]) {
      edges {
        node {
          id
          crop_name
          status
          yield_per_tray
          yield_unit
          total_grow_time
          sowing_density
          sow_density_unit
          steps {
            edges {
              node {
                id
                name
                time_to_start_after_first_step
              }
            }
          }
        }
      }
    }
  }
`;
